import axios from "axios";

export const get_orders = () => {
    return axios
        .get(
            "/api/orders",
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};
export const get_order = (id) => {
    return axios
        .get(
            "/api/orders/" + id,
            "",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            }
        )
};